module.exports = __webpack_public_path__ + "static/media/43.e19c9a9d.jpg";